"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescribeVersionsEnum = void 0;
var DescribeVersionsEnum;
(function (DescribeVersionsEnum) {
    DescribeVersionsEnum["v0"] = "v0";
    DescribeVersionsEnum["v1"] = "v1";
})(DescribeVersionsEnum = exports.DescribeVersionsEnum || (exports.DescribeVersionsEnum = {}));
